import React from "react";
import "./component.css";

export default function TabComponent({ data, handleFilter }) {
  return (
    <div className="flex overflow-auto gap-2 border">
      <button
        value={"ALL"}
        onClick={(e) => handleFilter(e.target.value)}
        className="capitalize-text rounded px-2 eventTypeBtn drop-shadow-md"
      >
        All
      </button>
      {data.map((type, index) => {
        return (
          <button
            onClick={(e) => handleFilter(e.target.value)}
            value={type.value}
            key={index}
            className="capitalize-text rounded px-2 eventTypeBtn drop-shadow-md"
          >
            {type.name}
          </button>
        );
      })}
    </div>
  );
}
